import {Component, EventEmitter, Input, Output, ViewEncapsulation} from "@angular/core";
import {Globals} from "../../../../globals";

/** Slim browse toolbar: keyword, sort, and list/panel layout. */
@Component({
  standalone: false,
  selector: 'app-basic-filter',
  templateUrl: './basic-filter.component.html',
  styleUrls: [ '../../ngslider.scss', '../../mat-checkbox.scss', '../../browse-filters-layout.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BasicFilterComponent {
  @Input() globals: Globals;
  @Input() searchKeyword = '';

  @Output() sortFilterChange = new EventEmitter<any>();
  @Output() listFilterChange = new EventEmitter<any>();
  @Output() panelFilterChange = new EventEmitter<any>();
  @Output() leftSidebarToggle = new EventEmitter<any>();
  @Output() searchKeywordChange = new EventEmitter<string>();

  onSearchKeywordChange(value: string): void {
    this.searchKeywordChange.emit(value ?? '');
  }

  onSortFilterChange(value: string) {
    this.sortFilterChange.emit(value);
  }

  onListFilterChange() {
    this.listFilterChange.emit();
  }

  onShowAsPanel() {
    this.panelFilterChange.emit();
  }

  onLeftSidebarToggle() {
    this.leftSidebarToggle.emit();
  }
}
